<div class="tableHolder table-responsive">
    <table mat-table [dataSource]="dataSource" class="table">
        <!-- media -->
        <ng-container matColumnDef="media">
            <th mat-header-cell *matHeaderCellDef>Media</th>
            <td mat-cell *matCellDef="let element">
                <img [src]="mediaUrl + '/iintegration/media/' + element.asset.fileName" alt="media" title="media"
                    width="100" class="br-15 img-fluid" *ngIf="element.asset" />
            </td>
        </ng-container>

        <!-- rule -->
        <ng-container matColumnDef="rule">
            <th mat-header-cell *matHeaderCellDef>Rule</th>
            <td mat-cell *matCellDef="let element">
                <span *ngIf="element.rule != -1">{{ element.rule }}</span>
                <span *ngIf="element.rule == -1">Generic</span>
            </td>
        </ng-container>

        <!-- plays -->
        <ng-container matColumnDef="plays">
            <th mat-header-cell *matHeaderCellDef># Plays</th>
            <td mat-cell *matCellDef="let element">{{ element.noOfPlays }}</td>
        </ng-container>

        <!-- impressions -->
        <ng-container matColumnDef="impressions">
            <th mat-header-cell *matHeaderCellDef>Impressions</th>
            <td mat-cell *matCellDef="let element">{{ element.noOfImpressions }}</td>
        </ng-container>

        <!-- cost -->
        <ng-container matColumnDef="cost">
            <th mat-header-cell *matHeaderCellDef>Cost</th>
            <td mat-cell *matCellDef="let element">
                <span *ngIf="element.cost != null">{{
                    element.cost.value | currency: element.cost.currencyCode
                    }}</span>
                <span *ngIf="element.cost == null">0</span>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
</div>